import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import Loader from '../Loader';


import config from '../../config/config';

import './CheckWebsiteUrls.css';
// import s from 'react-aws-s3';

function CheckWebsiteUrls() {
  const [running, setRunning] = useState(false);
  const [brokenLinks, setBrokenLinks] = useState([]);

  // console.log(Loader);  

  const handleSubmit = async () => {
    try {
      setRunning(true);
      const res = await axios.get(`${config.apiUrl}/api/listing/check-urls`);
      if (res.status === 200) {
        console.log('Urls checked');
        console.log(res.data);
        setBrokenLinks(res.data);
        setRunning(false);
      }
      else {
  
        console.log('Error checking urls');
        setRunning(false);
      }
    } catch (error) {
      setRunning(false);
    }
  }
  return (
    <div>
      <h1 style={{ marginBottom: 10 }}>Check Website Urls</h1>
      <Button
        disabled={running}
        onClick={handleSubmit}
        variant="contained"
      >Check</Button>


      <TableContainer style={{ marginTop: '30px' }} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Listing</TableCell>
              <TableCell>BrokenUrl</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {brokenLinks.map((row, i) => (
              <TableRow
                key={(row._id || row.name) + i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.website_url}</TableCell>
                <TableCell>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      color={'primary'}
                      name={'Edit'}
                      onClick={() => { window.open(row.website_url, '_blank') }}
                    >
                      Visit
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div 
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 20
        }}
      >
        <Loader loading={running} height={50} />
      </div>
    </div>
  )
}

export default CheckWebsiteUrls;